module.exports = __webpack_public_path__ + "static/media/addMore.1e95197e.svg";